export const wineColorCodes = [
    {wording: 'Blanc', code: '30002610'},
    {wording: 'Rouge', code: '30001983'},
    {wording: 'Rosé', code: '30002816'},
    {wording: 'Autre', code: '30002515'}
];
